import React from 'react';
import "./teaching.css";

export default class Teaching extends React.Component {
    render() {
        return (

            <div class="teaching">
		<h2>University of Washington</h2>
		    <li>CSE 446: Data Visualization (Fall 2026, Instructor)</li>
		<h2>University of Illinois</h2>
		    <li>CS 173: Discrete Structures (Spring 2025, TA)</li>
		    <li>CS 598KGK: Social Spaces on the Internet (Fall 2021, TA)</li>
		<h2>UC Berkeley</h2>
		    <li>CS 170: Efficient Algorithms and Intractable Problems (Spring 2018-Spring 2019, 1x TA, 2x Head TA)</li>
		    <li>CS 70: Discrete Mathematics and Probability Theory (Summer 2017, TA)</li>
	    </div>
	)
    }
}
